/**
 * File for string helper function
 */

export function stringIncludedIgnoreCase(
    firstString: string,
    secondString: string
): boolean {
    return firstString.toLowerCase().includes(secondString.toLowerCase());
}
